export interface PriorityContent {
  title: string
  overallGoals: string
  listItems: string[]
}

export const PRIORITY_CONTENT: Record<number, PriorityContent> = {
  1: {
    title: 'Priority 1: Professional Learning & Resource Dissemination',
    overallGoals: 'Develop and implement a professional learning (PL) plan for each ISD based on district needs.',
    listItems: [
      'Deliver PL using START content, resources, and tools based on identified needs in the PL plan.',
      'Access START training based on identified needs in the PL plan.',
      'Provide coaching follow-up as part of the PL plan to ensure implementation of training content.',
      'Develop an EPLI trainer plan based on relevant data and needs of the ISD.',
      'Identify at least one training delivered by EPLI Trainers to post on the START events page.',
      'Disseminate resources and tools (e.g., CETA, START-isms, behavior script template, family engagement practices) that support training content through meetings, newsletters, emails, social media, and other relevant outlets.'
    ]
  },
  2: {
    title: 'Priority 2: Coaching Structure and Systems',
    overallGoals: 'Develop a coaching structure within each ISD and district to support buildings and classrooms.',
    listItems: [
      'Each ISD establishes and sustains a coaching structure and plan with coach leaders and building coaches supported by START coaching resources.',
      'The ISD develops a plan to train and support district and building coaches to use effective coaching practices for the implementation of evidence-based practices (EBP). Use the Coaching Structure Checklist as a tool to guide your planning.',
      'Disseminate and model the use of resources and tools for coaching.'
    ]
  },
  3: {
    title: 'Priority 3: Coaching for Implementation of Evidence-based Practices',
    overallGoals: 'Coaches support classroom teams to set up class-wide evidence-based practices that are effective for all students and essential for some students. This includes use of the Classroom Environment and Teaching Assessment (CETA) as a collaborative tool to identify areas of strength and set goals in areas for further development. Students are supported through classroom and individual practices that meet a wide range of student goals.',
    listItems: [
      'Each ISD implements the CETA and collects Focus Student data in classrooms identified by the ISD.'
    ]
  },
  4: {
    title: 'Priority 4: Peer to Peer Programs',
    overallGoals: 'Peer to Peer programs are developed, expanded, and enhanced to support student access to peer programs. Fidelity tools and data are used to monitor program growth and quality.',
    listItems: [
      'Develop and implement a plan to expand the number of students accessing high-quality Peer to Peer opportunities.',
      'Identify activities to enhance the quality and scope of Peer to Peer programming.',
      'Establish a community of school staff dedicated to further improving Peer to Peer programming, developing resources for Peer to Peer, and disseminating information and resources in their region.',
      'Each ISD gathers information about the Peer to Peer programs in their districts and enters the data in the Peer to Peer Data Collection System.',
      'Support programs to complete a fidelity checklist each year and indicate completion in the Peer to Peer Data Collection System.'
    ]
  }
}
